module.exports = __webpack_public_path__ + "media/src/images/mails/badge_sop-79c7011c7c3477dc3afb8a5c2748fc3a.png";